/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: useCustomInView.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  06.06.23 11:36 am.
 * Last modified: 06.06.23 11:36 am.
 *
 * More information at: https://egt-digital.com/
 */
import { useInView } from 'react-intersection-observer';

export const useCustomInView = (threshold?: number): [(node?: Element | null) => void, boolean] => {
    const [jackpotRef, isVisible] = useInView({
        rootMargin: '0px',
        threshold: threshold || 0,
    });

    return [jackpotRef, isVisible];
};
